"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const Button_1 = __importDefault(require("../Button"));
const AlertDialog = (_a) => {
    var { open, handleClose, handleAvancar, titulo, btnCancelarDisabled, btnAvancarDisabled, btnCancelarTexto = 'Cancelar', btnAvancarTexto = 'Continuar', maxWidth, fullWidth, children } = _a, dialogProps = __rest(_a, ["open", "handleClose", "handleAvancar", "titulo", "btnCancelarDisabled", "btnAvancarDisabled", "btnCancelarTexto", "btnAvancarTexto", "maxWidth", "fullWidth", "children"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Dialog_1.default, Object.assign({ open: open, onClose: handleClose, maxWidth: maxWidth, fullWidth: fullWidth, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, dialogProps),
            react_1.default.createElement(DialogTitle_1.default, { id: "alert-dialog-title" }, titulo),
            react_1.default.createElement(DialogContent_1.default, null, children),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(Button_1.default, { onClick: handleClose, disabled: btnCancelarDisabled, color: "secondary" }, btnCancelarTexto),
                react_1.default.createElement(Button_1.default, { onClick: handleAvancar, color: "primary", 
                    // autoFocus
                    disabled: btnAvancarDisabled }, btnAvancarTexto)))));
};
exports.default = AlertDialog;
//# sourceMappingURL=index.js.map